import { render, staticRenderFns } from "./PayrollDeductionScheme.vue?vue&type=template&id=64d8ce1b&scoped=true&"
import script from "./PayrollDeductionScheme.vue?vue&type=script&lang=js&"
export * from "./PayrollDeductionScheme.vue?vue&type=script&lang=js&"
import style0 from "./PayrollDeductionScheme.vue?vue&type=style&index=0&id=64d8ce1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d8ce1b",
  null
  
)

export default component.exports